/** Default invite email HTML for Quill — plain semantic tags; editor styles supply font and wrapping. */
export const DEFAULT_INVITE_SUBJECT = "Greetings from Vidlet!";

export const APP_STORE_URL =
  "https://apps.apple.com/us/app/vidlet-3-0/id1604713113";
export const GOOGLE_PLAY_URL =
  "https://play.google.com/store/apps/details?id=com.vidlet.mobile";

export const DEFAULT_INVITE_EMAIL_HTML = `
<p>Thank you for agreeing to participate in this video research study.</p>
<p>You can download the apps from:</p>
<p><a href="${APP_STORE_URL}" target="_blank" rel="noopener noreferrer">Apple App Store</a><br /><a href="${GOOGLE_PLAY_URL}" target="_blank" rel="noopener noreferrer">Google Play Store</a></p>
<p>You can also search for "Vidlet 3.0" in both app stores.</p>
<p>Please keep the following guidelines in mind:</p>
<p><strong>GIVE DETAILED RESPONSES.</strong> Please be generous with details and try to avoid one-word responses or responses with no explanation. And while your responses will only be used internally, please be mindful not to share anything confidential.</p>
<p><strong>MAKE YOURSELF COMFORTABLE.</strong> Consider propping up your smartphone on a table or desk, so that you don't need to hold it while recording your video responses. And please BE SAFE: Under no circumstances should you record your responses while driving.</p>
`.trim();
